// tslint:disable max-line-length
import { injectGlobal } from 'styled-components';
import { Colors } from '@origin-digital/style-guide';
import { loadFonts } from 'html/assets/fonts';

export function injectGlobalStyles() {
  injectGlobal`
        /* 1. More sensible default box sizing.
         *    Resource: css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice
         * 2. Prevent adjustments of font size after orientation changes in iOS.
         * 3. Standardize 1rem to 10px, to make using rems easier.
         *    Resource: http://snook.ca/archives/html_and_css/font-size-with-rem
         * 4. Fonts are dynamically loaded depending on environment.
         */
        html {
            box-sizing: border-box; /* 1 */
            text-size-adjust: 100%; /* 2 */
            font-size: 62.5%; /* 3 */
            height: 100%;
        }

        body {
            margin: 0;
            font-family: Gordita, Arial, sans-serif;
            background: ${Colors.GREY8}
        }

        h1 {
            margin-top: 3.2rem;
            font-size: 1.8rem;
            font-weight: bold;
        }

        p {

            font-size: 1.6rem;
            font-weight: normal;
            line-height: 1.71;
        }
        ${loadFonts()}
    `;
}

export const hideCaptchaBadge = () => {
  injectGlobal`
        .grecaptcha-badge { visibility: hidden;}
    `;
};
